import { render } from "./ColoredOptionChip.vue?vue&type=template&id=40c1b88d&ts=true"
import script from "./ColoredOptionChip.vue?vue&type=script&lang=ts"
export * from "./ColoredOptionChip.vue?vue&type=script&lang=ts"

import "./ColoredOptionChip.vue?vue&type=style&index=0&id=40c1b88d&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__